import React, { useState } from "react";

import CreatePostModal from "../components/CreatePostModal";
import KpiCards from "../components/KpiCards";
import NewsBanner from "../components/NewsBanner";
import NewsCharts from "../components/NewsCharts";
import PostList from "../components/PostList";
import RecentDocuments from "../components/RecentDocuments";
import TickerNoticeBar from "../components/TickerNoticeBar";

const MOCK_INITIAL_POSTS = [
  {
    id: 1,
    author: "ADMIN",
    isNew: true,
    isPinned: true,
    date: "21-09-2026",
    title: "Thông báo bản cập nhật 21.9.",
    bullets: [
      "Tối ưu bộ lọc thông báo.",
      "Xử lý lại avatar người dùng bị lỗi khi kế thừa từ app nhân viên.",
      "Bổ sung tính năng duyệt nhanh (nút dễ bấm và tương thích hơn với mobile).",
      "Tối ưu phương thức lấy danh sách lịch chi phiếu thu, phiếu chi (Tốc độ lấy phiếu nhanh hơn)",
      "Sửa công thức và trạng thái báo cáo kế toán lúc chưa đồng bộ, cải thiện bộ lọc",
      "Thêm đánh dấu phiếu đã duyệt xong",
    ],
    comments: [],
  },
];

export default function NewsFeedPage() {
  const [posts, setPosts] = useState(MOCK_INITIAL_POSTS);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleCreatePost = (newPost) => {
    setPosts([newPost, ...posts]);
  };

  return (
    <div className="min-h-screen bg-gray-50/50 p-4 md:p-6 lg:p-8 space-y-6">
      {/* 1. Header Banner */}
      <NewsBanner />

      {/* 2. Today's Ticker / Notice Bar */}
      <TickerNoticeBar />

      {/* 3. Summary KPI Cards */}
      <KpiCards />

      {/* 4. Charts Row */}
      <NewsCharts />

      {/* 5. Main Content Grid (Left: Feed Posts, Right: Recent Documents) */}
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 items-start">
        {/* Left Column (8 cols ~ 70%) */}
        <div className="lg:col-span-8">
          <PostList
            posts={posts}
            onOpenCreateModal={() => setIsModalOpen(true)}
          />
        </div>

        {/* Right Column (4 cols ~ 30%) */}
        <div className="lg:col-span-4">
          <RecentDocuments />
        </div>
      </div>

      {/* 6. Modal for creating new post */}
      <CreatePostModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSubmit={handleCreatePost}
      />
    </div>
  );
}
